import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type GreenChargingIconProps = {
    color?: string
    size?: number
    className?: ClassName
    style?: React.CSSProperties
}

export function GreenChargingIcon({
    className,
    style,
    size = 65,
    color = '#006c5c',
}: GreenChargingIconProps): React.ReactElement {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 81 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
            data-testid={`greenCharging`}
        >
            <g clipPath="url(#a)" fill={color}>
                <path d="M36.273 43.599c-7.485 21.623-6.845 22.39-6.013 23.126l.575.544h.736c.896 0 2.111 0 24.886-30.356l1.92-2.59H44.398c4.638-20.217 3.55-20.729 2.303-21.304-1.247-.576-2.463-1.184-23.03 30.292l-1.632 2.495H32.5v-3.2H28.02c6.11-9.307 12.635-18.872 16.185-23.67-.64 4.095-2.015 10.652-3.39 16.666l-.48 1.983h11.58c-5.727 7.58-13.244 17.305-17.658 22.71 1.216-4.126 3.199-10.043 5.086-15.545l-3.07-1.151Z" />
                <path d="M39.92 76.674A37.265 37.265 0 0 1 7.933 58.056l8.093 1.92.735-3.2-13.37-3.198-3.2 13.53 3.2.736 1.95-8.093a40.463 40.463 0 0 0 34.579 20.12 40.336 40.336 0 0 0 40.304-40.304h-3.199A37.105 37.105 0 0 1 39.92 76.674ZM40.4 3.103A37.265 37.265 0 0 1 72.547 21.75l-8.093-1.92-.767 3.2 13.402 3.198 3.2-13.53-3.2-.768-1.919 8.125A40.56 40.56 0 0 0 40.4-.096 40.368 40.368 0 0 0 .096 40.208h3.199A37.137 37.137 0 0 1 40.4 3.103Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h80.288v80H0z" />
                </clipPath>
            </defs>
        </svg>
    )
}
